import moment from "moment-timezone";

export const SORT_FUNCTION = {
  date_asc: function(a, b) {
    const dateA = moment(a.dateStart);
    const dateB = moment(b.dateStart);

    if (dateA.isValid() && dateB.isValid()) {
      return dateA.isBefore(dateB) ? -1 : dateA.isAfter(dateB) ? 1 : 0;
    } else if (dateA.isValid()) {
      return -1;
    } else if (dateB.isValid()) {
      return 1;
    }
    return 0;
  },
  date_desc: function(a, b) {
    const dateA = moment(a.dateStart);
    const dateB = moment(b.dateStart);

    if (dateA.isValid() && dateB.isValid()) {
      return dateB.isBefore(dateA) ? -1 : dateB.isAfter(dateA) ? 1 : 0;
    } else if (dateA.isValid()) {
      return -1;
    } else if (dateB.isValid()) {
      return 1;
    }
    return 0;
  },
};